export default __webpack_public_path__ + "static/media/gallery-wip-pommel_06.4d6002e2.jpg";